import { Component, OnInit, Output, Input, EventEmitter, HostListener, ElementRef, SimpleChanges, ChangeDetectionStrategy, ViewChild, AfterViewInit, OnDestroy, OnChanges, ChangeDetectorRef, forwardRef } from '@angular/core';
import { GlobalService } from '../services/global.service';
import { SearchPipe } from '../pipes/search.pipe';
import { fromEvent, Observable, Subscription } from 'rxjs';
import * as _ from 'lodash';
import {
	NG_VALUE_ACCESSOR,
	NG_VALIDATORS,
	Validator,
	AbstractControl,
	UntypedFormControl,
	ControlValueAccessor
}
	from '@angular/forms';
import { get } from 'https';

@Component({
    selector: 'app-minutes-input',
    templateUrl: './minutes-input.component.html',
    styleUrls: ['./minutes-input.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MinutesInputComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MinutesInputComponent),
            multi: true,
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class MinutesInputComponent implements OnInit, OnChanges, ControlValueAccessor {
	@ViewChild('theInput', { static: false }) theInput: ElementRef;
	@Input() appModel: any;
	@Input() list: any = [];
	@Input() valueId: string;
	@Input() useTrackBy: boolean = false;
	@Input() nameLabel: string;
	@Input() placeholder: string;
	@Input() required: boolean = false;
	@Input() backTranslate: boolean;
	@Input() toCreate: boolean;
	@Input() multiple: boolean;
	@Input() debug: boolean;
	@Input() showEmpty: boolean;
	@Input() color: boolean;
	@Input() disabled: boolean;
	@Input() big: boolean;
	@Input() colored: boolean;



	@Input() createValue: string;
	@Input() uppercase: boolean;
	@Input() keepOpen: boolean = true;
	@Input() showCheckboxOptions: boolean = false;

	@Output() appModelChange = new EventEmitter<string>();
	@Output() createValueChange = new EventEmitter<string>();
	@Output() appChange = new EventEmitter<string>();
	@Output() onClose = new EventEmitter<string>();
	// document.activeElement

	minutes: string;
	seconds: string;

	onChange: any = () => { };
	onTouched: any = () => { };


	filteredList: any = [];
	inputValue: string;
	searchvalue: string;

	showOptions: boolean = false;
	wasInside: boolean = false;
	itemWasSelected: boolean = false;
	firstOpen: boolean = false;
	wasClickNav: boolean = false;

	sliceStart: number = 0
	sliceLength: number = 25
	sliceEnd: number = this.sliceLength
	selected_color: any = [];
	subs: Subscription[] = [];
	$documentClick: Observable<Event>;
	$inputClick: Observable<Event>;


	value: any;

	constructor(
		private _elementRef: ElementRef,
		public _gS: GlobalService,
		private _SearchPipe: SearchPipe,
		private _cD: ChangeDetectorRef) { }


	clickEmpty() {
		this.appModel = undefined
		this.appModelChange.emit(this.appModel);
		this.setValueControl(this.appModel)
	}

	onChangeHandler() {
		if (!this.minutes && this.seconds) {
			this.minutes = '0'
		}
		var min = this.minutes
		var sec = this.seconds

		var a: number = min ? parseInt(min) : 0;
		var b: number = sec ? parseInt(sec) : 0;

		this.appModel = (a * 60) + b;
		if (b > 59) {
			this.appModel = undefined
		}
		this.appModelChange.emit(this.appModel);
		this.setValueControl(this.appModel)
	}
	setValues(ev) {
		this.minutes = Math.floor(ev / 60).toString();
		this.seconds = (ev - (Math.floor(ev / 60) * 60)).toString();
		if (this.seconds == '0') {
			this.seconds = '00'
		} else if (parseInt(this.seconds) < 10 && this.seconds.length < 2) {
			this.seconds = '0' + parseInt(this.seconds)
		}
		this.saveTime();
	}
	saveTime() {
		this.appChange.emit();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.appModel) {
			
			if (changes.appModel.currentValue) {
				this.setValues(changes.appModel.currentValue)
			}
		}
	}

	ngOnInit() {
	}

	setValueControl(value) {
		this.value = value
		this.onChange(value)
	}

	public writeValue(value: any): void {
		this.value = value;
	}

	public registerOnChange(fn: any): void {
		this.onChange = fn;
	}
	public registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
	setDisabledState?(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}


	public validate(c: UntypedFormControl) {
		return (this.value) ? null : {
			inputError: {
				valid: false,
			},
		};
	}

}
